<script>
  import { afterUpdate,createEventDispatcher } from "svelte";  
  const dispatch = createEventDispatcher();
  export  let items=[];
  export let selected; 
  export let disabled = false;
  export let value = 'id';
  export let label = 'text';
  export let placeholderText = '';
  export let width = 100;
  export let style = '';

  let component;

  afterUpdate(()=>{
   
  selected = component.value;
  })

  export const handleChange = (e) => {


		dispatch('change');
	}
 
</script>

<select bind:this={component} class="form-control" style="padding:0.2rem; width: {width}%; display: inline-block; {style}" bind:value={selected} disabled={disabled} 	on:change={handleChange} on:blur={dispatch("blur")}>  
    <option value="">--- Please select {placeholderText}---</option> 

    {#each items as item}
        <option value={item[value]}>
            {item[label]}
        </option>
    {/each}
</select>